import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Fraccionamientos from "@/pages/Fraccionamientos";
import FraccionamientoDetalle from "@/pages/FraccionamientoDetalle";
import Lotes from "@/pages/Lotes";
import Clientes from "@/pages/Clientes";
import Tratos from "@/pages/Tratos";
import Pagos from "@/pages/Pagos";
import Papelera from "@/pages/Papelera";
import Equipo from "@/pages/Equipo";
import AcceptInvitation from "@/pages/AcceptInvitation";
import ActivarComisionista from "@/pages/ActivarComisionista";
import Subscription from "@/pages/Subscription";
import SubscriptionSuccess from "@/pages/SubscriptionSuccess";
import SubscriptionCancel from "@/pages/SubscriptionCancel";
import ResetPassword from "@/pages/ResetPassword";
import Precios from "@/pages/Precios";
import Solicitudes from "@/pages/Solicitudes";
import Comisionistas from "@/pages/Comisionistas";
import Comisiones from "@/pages/Comisiones";
import MisApartados from "@/pages/MisApartados";
import MisVentas from "@/pages/MisVentas";
import MisComisiones from "@/pages/MisComisiones";
import ProtectedRoute from "@/components/ProtectedRoute";
import { ComisionistaLayout } from "@/components/ComisionistaLayout";
import { Toaster } from "@/components/ui/sonner";
import { FraccionamientoProvider } from "@/contexts/FraccionamientoContext";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/precios" element={<Precios />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/invitation/:token" element={<AcceptInvitation />} />
      <Route path="/activar-comisionista" element={<ActivarComisionista />} />
      <Route path="/subscription" element={<Subscription />} />
      <Route path="/subscription/success" element={<SubscriptionSuccess />} />
      <Route path="/subscription/cancel" element={<SubscriptionCancel />} />

      {/* Portal Comisionista — layout propio */}
      <Route path="/portal-comisionista" element={<ComisionistaLayout><Lotes /></ComisionistaLayout>} />
      <Route path="/portal-comisionista/mis-apartados" element={<ComisionistaLayout><MisApartados /></ComisionistaLayout>} />
      <Route path="/portal-comisionista/mis-ventas" element={<ComisionistaLayout><MisVentas /></ComisionistaLayout>} />
      <Route path="/portal-comisionista/mis-comisiones" element={<ComisionistaLayout><MisComisiones /></ComisionistaLayout>} />

      {/* Admin routes — wrapped in ProtectedRoute (includes SidebarLayout) */}
      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/fraccionamientos" element={<ProtectedRoute><Fraccionamientos /></ProtectedRoute>} />
      <Route path="/fraccionamientos/:id" element={<ProtectedRoute><FraccionamientoDetalle /></ProtectedRoute>} />
      <Route path="/lotes" element={<ProtectedRoute><Lotes /></ProtectedRoute>} />
      <Route path="/clientes" element={<ProtectedRoute><Clientes /></ProtectedRoute>} />
      <Route path="/tratos" element={<ProtectedRoute><Tratos /></ProtectedRoute>} />
      <Route path="/pagos" element={<ProtectedRoute><Pagos /></ProtectedRoute>} />
      <Route path="/papelera" element={<ProtectedRoute><Papelera /></ProtectedRoute>} />
      <Route path="/solicitudes" element={<ProtectedRoute><Solicitudes /></ProtectedRoute>} />
      <Route path="/comisionistas" element={<ProtectedRoute><Comisionistas /></ProtectedRoute>} />
      <Route path="/comisiones" element={<ProtectedRoute><Comisiones /></ProtectedRoute>} />
      <Route path="/equipo" element={<ProtectedRoute><Equipo /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <FraccionamientoProvider>
          <AppRouter />
          <Toaster />
        </FraccionamientoProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
